<script>
  export let separator = 'OR';
</script>

<div class="mt-md flex w-full items-center {$$props.class}">
  <div class="bg-gray-dark-1 h-px flex-1" />
  <p class="font-architekt text-gray-dark-11 text-sm font-normal leading-[10px]">
    {separator}
  </p>
  <div class="bg-gray-dark-1 h-px flex-1" />
</div>
